// `/app/developers/events` (`spec/17-frontend.md` §8.1, croqui `screens/seller/eventos.tsx`).
// Foco: **o feed**.
//
// Só roteador: o schema de `search`, a navegação e nada mais. A tela é
// `features/events/events-screen.tsx`.
//
// Não há rota `$id` aqui (nem em `files_allowed` desta task), então a gaveta vive em
// `?event=`, mesmo efeito da decisão 5 de `spec/24` §1: recarregar e compartilhar o
// link reabrem o mesmo evento, com a lista embaixo.
//
// Dois endpoints com papéis distintos (`spec/17` §8.3): `GET /v1/me/events` é a listagem
// paginada; o stream ao vivo é `GET /events` e quem o abre é o `useLiveEvents()` do
// shell. Esta tela não abre um segundo `EventSource`: lê o status por `useLiveStatus()`.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { type EventsFilter, EventsScreen } from '../features/events/events-screen.tsx';

/** Query string tolerante a lixo: `?type=banana` cai em `undefined` (`catch` do Zod). */
const searchSchema = z.object({
  event: z.string().min(1).optional().catch(undefined),
  type: z.string().min(1).optional().catch(undefined),
  resource: z.string().min(1).optional().catch(undefined),
  /** Internos escondidos por default; `?internos=1` liga (`spec/24` §5, WEB-59). */
  internos: z.literal(1).optional().catch(undefined),
});

function Events() {
  const search = Route.useSearch();
  const navigate = useNavigate();

  const filter: EventsFilter = {
    type: search.type,
    resourceId: search.resource,
    internal: search.internos === 1,
  };

  const go = (next: EventsFilter, event: string | undefined): void => {
    void navigate({
      to: '/app/developers/events',
      search: {
        ...(event === undefined ? {} : { event }),
        ...(next.type === undefined ? {} : { type: next.type }),
        ...(next.resourceId === undefined ? {} : { resource: next.resourceId }),
        ...(next.internal ? { internos: 1 as const } : {}),
      },
      replace: true,
    });
  };

  return (
    <EventsScreen
      filter={filter}
      selectedId={search.event}
      onFilterChange={(next) => {
        // Trocar o filtro fecha a gaveta: o evento aberto pode não estar no novo recorte.
        go(next, undefined);
      }}
      onSelect={(id) => {
        go(filter, id);
      }}
    />
  );
}

export const Route = createFileRoute('/app/developers/events/')({
  validateSearch: searchSchema,
  component: Events,
});
